import { composeReducer } from 'redux-compose-reducer';

export const initialPagination = { current: 0, pageSize: 15, total: 16 };

const initialState = {
  conversations: [],
  pagination: initialPagination
};

function getConversations(state, { data, pagination }) {
  const { offset } = data.pagination;
  const conversations = state.conversations;
  data.data.forEach((v, i) => conversations[offset + i] = v);

  return {
    ...state,
    conversations,
    pagination: { ...state.pagination, ...pagination, ...data.pagination }
  };
}

function clearConversations(state) {
  return {
    ...state,
    conversations: [],
    pagination: initialPagination
  };
}

export default composeReducer('coversations', {
  getConversations,
  clearConversations
}, initialState);



// WEBPACK FOOTER //
// ./src/reducers/conversations.js